(function() {
    'use strict';

    angular.module('remitEventsApp').service('EventService', function(HelpersService) {
        var scrolling;

        this.scrollTable = function(amount, element) {
            var sideGraph = HelpersService.findElement(element ? element : '.side-graph.right');

            scrolling = setInterval(function() {
                var scrollLeft = sideGraph.element.scrollLeft;

                sideGraph.scrollLeft(scrollLeft + amount);
            }, 30);
        };

        this.stopScroll = function() {
            if (scrolling) {
                clearInterval(scrolling);
                scrolling = null;
            }
        };

        this.setTablePosition = function() {
            var widthTable =
                HelpersService.findElement('.table-data-scroll').width() + HelpersService.findElement('.left-content-table').width() + 30;
            var widthContainer = HelpersService.findElement('.events-data').width();
            var $rigthScrollControl = HelpersService.findElement('.scroll-bar.right');
            var $leftScrollControl = HelpersService.findElement('.scroll-bar.left');

            if (widthTable < widthContainer) {
                $rigthScrollControl
                    .css({
                        left:
                            HelpersService.findElement('.table-data-scroll table tr:first-child td:last-child').position().left +
                            HelpersService.findElement('.table-data-scroll table tr:first-child td:last-child').width() +
                            HelpersService.findElement('.left-content-table').width() +
                            15
                    })
                    .addClass('disabled');
                $leftScrollControl.addClass('disabled');
            } else {
                $rigthScrollControl
                    .removeAttr('style')
                    .css({ right: '14px' })
                    .removeClass('disabled');
                $leftScrollControl.removeClass('disabled');
            }
        };
    });
})();
